import './index.scss'
import { useState } from 'react'
import ProjectPreview from '../ProjectPreview'
import bhamLogo from '../../assets/images/bham_logo.png'
import projects from '../../data/projects'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'

// projects list now lives in src/data/projects.js

const ProjectsPage = () => {
  const visible = projects.filter((p) => p.visible)
  const [slide, setSlide] = useState(0)
  const lastSlide = visible.length - 2
  const visibleProjects = visible.slice(slide, slide + 2)

  return (
    <main className="projects-page">
      <div className="site-container">
      <section className="projects-hero">
        <div className="projects-hero__content">
          <p className="eyebrow">Projects</p>
          <h1>Selected work</h1>
          <h2>Projects spanning NLP, machine learning, full-stack development, and systems design</h2>
          <p>
            These projects reflect my experience building practical software, working in teams, and applying modern development practices to real problem areas.
          </p>
        </div>
      </section>


      <section className="projects-carousel" aria-label="Projects carousel">
        <button
          type="button"
          className="carousel-button"
          onClick={() => setSlide((currentSlide) => currentSlide - 1)}
          disabled={slide === 0}
          aria-label="Previous projects"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>

        <div className="projects-grid" key={slide}>
          {visibleProjects.map((project) => (
            <ProjectPreview
              key={project.title}
              title={project.title}
              excerpt={project.description}
              to={`/projects/${project.slug}`}
              image={project.image || bhamLogo}
              skills={project.skills}
            />
          ))}
        </div>

        <button
          type="button"
          className="carousel-button"
          onClick={() => setSlide((currentSlide) => currentSlide + 1)}
          disabled={slide === lastSlide}
          aria-label="Next projects"
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </section>
      </div>
    </main>
  )
}

export default ProjectsPage
